<app-promotion-list-tile
        *ngFor="let promotion of promotions"
        [promotion]="promotion"
        [isClickable]="navigateOnClick"
        (onClick)="goToPromotionDetail(promotion.code)"
></app-promotion-list-tile>
